import { useState } from "react";
import { Share2, Check } from "lucide-react";
import { toast } from "sonner";

// Legacy clipboard fallback for browsers/contexts where the async
// Clipboard API is unavailable or blocked.
function legacyCopy(text) {
  try {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.style.position = "fixed";
    ta.style.top = "-1000px";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
}

// Small, reusable "Share this page" button. On devices with the Web Share
// API (mostly phones) it opens the native share sheet; everywhere else it
// copies the current page's clean URL and shows a toast.
export const ShareButton = ({ title, className = "", testid = "share-btn" }) => {
  const [copied, setCopied] = useState(false);

  const share = async () => {
    const url =
      typeof window !== "undefined"
        ? "https://cphhighlights.com" + window.location.pathname
        : "";
    const shareTitle = title || (typeof document !== "undefined" ? document.title : "CPH Highlights");

    if (navigator.share) {
      try {
        await navigator.share({ title: shareTitle, text: shareTitle, url });
      } catch {
        /* user cancelled — ignore */
      }
      return;
    }

    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success("Link copied — share it with your friends!");
      setTimeout(() => setCopied(false), 2000);
    } catch {
      if (legacyCopy(url)) {
        setCopied(true);
        toast.success("Link copied — share it with your friends!");
        setTimeout(() => setCopied(false), 2000);
      } else {
        toast.error("Couldn't copy the link. Please copy it from the address bar.");
      }
    }
  };

  return (
    <button
      type="button"
      onClick={share}
      data-testid={testid}
      className={`inline-flex items-center gap-2 font-body font-700 text-sm px-4 py-2 rounded-full border border-zinc-300 bg-white text-black hover:border-black hover:-translate-y-0.5 transition-all ${className}`}
    >
      {copied ? <Check size={16} /> : <Share2 size={16} />}
      {copied ? "Copied" : "Share"}
    </button>
  );
};
